import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

// 前端錯誤監控，僅正式環境送出（本機開發不干擾除錯）
export function initSentry(app: App) {
  Sentry.init({
    app,
    dsn: 'https://888d896d0e5835c38438811b44c5c139@o4511872997523456.ingest.us.sentry.io/4511873007812608',
    environment: import.meta.env.DEV ? 'development' : 'production',
    // 標記錯誤來自哪一版 build，用來分辨使用者是否停在舊版分頁
    release: __BUILD_ID__,
    enabled: !import.meta.env.DEV,
  })
}
